import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";

export default function MasterUrlEdit() {
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let masterUrlId = decode.id;

    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    const navigate = useNavigate();

    let refName = React.useRef();
    let refUrl = React.useRef();

    React.useEffect(() => {
        (async function() {
            try { 
                const resView = await getView();
                setData(resView);
                setStatusChecked(resView.status===1);
                refName.current.value = resView.name;
                refUrl.current.value = resView.url;

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/masterUrl/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: masterUrlId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = () => {
        let name = refName.current.value;
        let url = refUrl.current.value;

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ");
            refName.current.focus();
        }
        else if(!url) {
            toast.error("กรุณาระบุ URL");
            refUrl.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                id: data.id,
                                name: name,
                                currentName: data.name,
                                url: url.toString().trim(),
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.url.API_URL +'/api/masterUrl/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/masterUrl', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeStatus = (e) => {
        setStatusChecked(e.target.checked);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Master URL</div>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="url" className="form-label">URL <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="url" ref={refUrl} maxLength={250} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => onChangeStatus(e)} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/masterUrl'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 